import { Injectable } from '@angular/core';
import { Router } from '@angular/router';


@Injectable({ providedIn: 'root' })
export class PublicCardApplicationRouteManager {
  constructor(
    private router: Router,
  ) {}

  public isPublicCardApplication(): boolean {
    return this.router.config[0]?.path === 'apply-cards';
  }
}
